module.exports = __webpack_public_path__ + "img/tab-season-active.2d18bd93.png";